import React from "react";
import { Tag } from "antd";

/**
 * Nhãn / màu / cách đọc dữ liệu của vé "Yêu cầu hỗ trợ".
 *
 * Danh mục nội dung (subtype) KHÔNG nằm ở đây — nó lấy từ API `/tickets/meta`
 * để backend là nguồn duy nhất, tránh cảnh mỗi app một bản rồi lệch nhau như
 * nhãn trạng thái phản ánh từng bị.
 */

/**
 * Nhãn trạng thái PHẢI trùng chữ với mini app cư dân
 * (`one-egovernment/src/pages/Ticket/ticketMeta.ts`). Lệch chữ là cư dân gọi lên
 * phường nói "đang xác minh" còn cán bộ nhìn màn hình thấy "đang xử lý" — đúng
 * lỗi đã từng xảy ra với module Phản ánh.
 */
const STATUS_META = {
  received: { label: "Đã gửi", color: "blue" },
  processing: { label: "Đang xác minh", color: "orange" },
  completed: { label: "Hoàn thành", color: "green" },
  rejected: { label: "Từ chối", color: "red" },
  cancelled: { label: "Cư dân đã hủy", color: "default" },
};

export const statusTag = (status) => {
  const meta = STATUS_META[status];
  return meta ? <Tag color={meta.color}>{meta.label}</Tag> : <Tag>{status}</Tag>;
};

export const STATUS_OPTIONS = Object.entries(STATUS_META).map(([value, meta]) => ({
  value,
  label: meta.label,
}));

/**
 * Mã vé hiển thị.
 *
 * Bảng không có cột mã riêng — đây là `id` được đệm số 0 để đọc qua điện thoại.
 * Cư dân và cán bộ phải thấy cùng một mã thì mới tra chéo được, nên mini app
 * dùng đúng công thức này.
 */
export const ticketCode = (id) => `#YC${String(id).padStart(5, "0")}`;

/**
 * Loại tài khoản gửi vé THAY cư dân (trưởng khu phố, từ app quản lý). PHẢI khớp
 * `Reflection::STAFF_REQUESTER_TYPES` ở backend.
 */
const STAFF_REQUESTER_TYPES = ["BRANCH_MANAGER", "STAFF"];

/**
 * Người gửi khi vé do trưởng khu phố gửi thay cư dân; `null` nếu cư dân tự gửi.
 *
 * Cần tách vì hai loại vé xét khác nhau: vé cư dân thì người gửi chính là chủ hồ
 * sơ, còn vé này người gửi là cán bộ — phường phải biết ai đề nghị để hỏi lại.
 */
export const staffRequesterOf = (ticket) => {
  const user = ticket?.user;
  if (!STAFF_REQUESTER_TYPES.includes(user?.info?.type)) return null;

  return {
    name: user.staff?.name || user.info?.name || user.username,
    phone: user.staff?.phone || user.phone,
  };
};

/**
 * Giá trị ĐANG lưu trong hồ sơ, ứng với từng nội dung đề nghị sửa.
 *
 * Có nó thì màn duyệt hiện được hai cột "Hiện tại | Đề nghị" để cán bộ đối
 * chiếu trong vài giây, thay vì mở hồ sơ ở tab khác ra dò.
 */
export const currentValueOf = (ticket) => {
  const customer = ticket?.customer;
  if (!customer) return null;

  switch (ticket.subtype) {
    case "customer_name": return customer.name;
    case "contact_phone": return customer.phone || ticket.phone;
    case "address": return customer.address;
    default: return null;
  }
};
